export const HorairesOuverture = ({ horaires }) => {
    const joursOrdre = [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche",
    ];

    return (
        <div className="bg-white p-4 rounded-xl shadow-md max-w-md w-full">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <span className="mr-2">🕒</span> Horaires d’ouverture
            </h3>
            <ul className="text-sm text-gray-700">
                {joursOrdre.map((jour) => (
                    <li
                        key={jour}
                        className="flex justify-between border-b last:border-b-0 py-1"
                    >
                        <span className="w-24 font-medium">{jour}</span>
                        {horaires[jour] && horaires[jour].length > 0 ? (
                            <span className="text-right space-x-1">
                                {horaires[jour]
                                    .map(
                                        (plage) =>
                                            `${plage.debut} – ${plage.fin}`
                                    )
                                    .join(" / ")}
                            </span>
                        ) : (
                            <span className="italic text-gray-500">Fermé</span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};
